import React from 'react'
import { Skeleton, Stack, Chip, Grid } from '@mui/material'
import { Outlet, useLocation, useNavigate, useParams } from 'react-router-dom'
import { useGetTrackQuery } from '../../api/trackApiSlice'
import { useGetUserQuery } from '../../api/userApiSlice'
import TrackSideMenu from './components/board/TrackSideMenu'

const chipStyle = { 
    color:'#FFF',
    height: '2.8vh',
    borderRadius: '1.3vh',
    fontFamily: 'Montserrat',
    fontSize: '1rem',
    margin: '0 8px',
    background: '#00000080',
    padding: '8px',
    '& span': {padding: '0 18px'}
}

const TrackBoard = () => {
    let { id } = useParams()
    const navigate = useNavigate()
    const location = useLocation()

    const {
        data: user
    } = useGetUserQuery({})

    const {
        data: track,
    } = useGetTrackQuery({id, user_id: user ? user._id : null})

    const showTeam = () => {
        navigate('team')
    }

    const showStats = () => {
        navigate('stats')
    }

    return track && track !== null
    ? 
        <Grid container spacing={2} sx={{height: '100%', pb: {xs:'17%', md:'5%', lg: 0}}}>
            <TrackSideMenu />
            <Grid size={{ lg: 8, xs: 12}} sx={{height: {xs:'65%', md:'50%',lg:'100%'}, position: 'relative', borderRadius: '16px'}}>
                <Stack direction={'column'} alignItems={'center'} sx={{height: '100%', borderRadius: '16px', backdropFilter: 'blur(20px)  brightness(70%)'}} >
                    <Stack direction={'row'} sx={{overflowY: 'hidden', overflowX: 'hidden', p: 2}} >
                        <Chip 
                            key={'Équipe'}
                            label={'Équipe'}
                            variant={!location.pathname.includes('stats') ? 'outlined' : 'filled' }
                            sx={chipStyle}
                            onClick={showTeam} />
                        <Chip 
                            key={'Stats'}
                            label={'Stats'}
                            variant={location.pathname.includes('stats') ? 'outlined' : 'filled' }
                            sx={chipStyle}
                            onClick={showStats} />
                    </Stack>
                    <Outlet />
                </Stack>
            </Grid>
        </Grid>
    : 
        <Skeleton/>
}


export default TrackBoard